<template>
<layout v-bind:user="user" v-bind:shops="shops" v-bind:brands="brands" v-bind:company="company" title="コンポーネント作成用" @selectList="displaySelectedBrand($event)">

<main class="ly_main">
    <div class="wrap">
        <div class="inner">

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                PageHeading

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>Component</span></div>
            </h1>
            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                入力フォーム一覧

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>入力フォーム一覧</span></h2>
            <div class="comment">
                <p>管理画面で使用する入力フォームの一覧。全体を<code>.form_admin-container</code>で括って使用すると自動的にmargin等も設定される。</p>
                <p><code>.input-group</code>で括ると罫線と余白が追加されてグループ分けされます。基本<code>.input-group</code>で括って使うように作ってます。</p>
            </div>
            <InputComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                バリデーションエラー

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>バリデーションエラー</span></h2>
            <div class="comment">
                <p>エラーの input と label に対して<code>._error</code>を付与するとバリデーションエラー表示になります。</p>
                <p>さらに追加で<code>._required</code>を付与すると必須項目を求める表示になります。</p>
            </div>
            <InputValidationComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ボタン一覧

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>リンクボタン一覧</span></h2>
            <div class="comment">
                <p>アイコンはsvgファイルをcomponentsでimportして使用。他に必要なものが随時追加するのであれば言ってください。</p>
                <p>リンク先はアテに入れてます。</p>
            </div>
            <LinkBtnComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                アイコンボタン一覧

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>アイコンボタン一覧</span></h2>
            <div class="comment">
                <p><code>.btn_svg-icon</code>を付けるだけなので aタグでも buttonタグでも divタグでもOKです</p>
            </div>
            <IconBtnComponent />


            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                新着アイコンボタン一覧

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>新着アイコンボタン一覧</span></h2>
            <div class="comment">
                <p><code>.btn_svg-icon</code>に<code>._notice</code>のヘルパークラスを付けると新着がある表示。</p>
            </div>
            <IconBtnNoticeComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ブランド- 個人設定 - ユーザー情報

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ブランド- 個人設定 - ユーザー情報</span></h2>
            <div class="comment">
                <p>メニュー量が増えた際とMoblieに対応できるように、ボタン部分にSwiperを使って横スクロールに対応させてます。この見本ではわざとボタンの量を増やしているので、実装時に適正量に減らしてください。</p>
            </div>
            <UserSettingComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ブランド - お知らせ詳細 最近のお知らせ表示あり

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ブランド - お知らせ詳細 : 最近のお知らせ表示あり</span></h2>
            <div class="comment">
                <p>最近のお知らせ、という直近5件程度のお知らせが見れる要素があったほうが、一々一覧に戻る頻度を削減できるので一応入れてます。2月の実装間に合わなければ3月で。念の為この「最近のお知らせ」無いパターンも用意しておきました。</p>
            </div>
            <NewsRecentComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ブランド - お知らせ詳細 最近のお知らせ表示なし

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ブランド - お知らせ詳細 : 最近のお知らせ表示なし</span></h2>
            <div class="comment">
                <p>最近のお知らせ表示なし</p>
            </div>
            <NewsComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                お知らせ新規作成＆編集画面

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>お知らせ新規作成＆編集画面</span></h2>
            <div class="comment">
                <p>入力する際に出現する<a href="https://gyazo.com/11f293fc9c1e61e28ac569e048d9ad50" target="_blank"><b><u>このプラスアイコン</u></b></a>は今の所必要無い気がしたので<code>_editor.scss</code>で非表示にしています。ステータスと送信先は初期値何かしらを選択させた状態にしておいたほうが操作ミスが減ると思うので、ステータス => 下書き / 送信先 => 全体 を初期値として<code>checked</code>させておいた方が良いかも。</p>
                <p>・入力エリアに初期表示されている No content は「入力してください」に変えたほうが良いかも。</p>
                <p>・BackSpaceを押すと一行丸々消えてしまうのはどうにかできるならしたほうが良いかも。</p>
            </div>
            <NewsRegisterComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ページネーション

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ページネーション</span></h2>
            <div class="comment">
                <p></p>
            </div>
            <PaginationComponent />

        <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

            ブランド_トーク画面は100％で表示したいので一旦全体の .wrap を解除

        :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
        </div><!--/.ly_main .inner-->
    </div><!--/.ly_main .wrap-->

    <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

        ブランド_トーク画面

    :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
    <TalkComponent />

    <div class="wrap">
        <div class="inner">

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ブランド - アプローチDM新規作成

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ブランド - アプローチDM新規作成</span></h2>
            <div class="comment">
                <p>xxxxxx</p>
            </div>
            <DmRegisterComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ブランド- DM設定_ON

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ブランド- DM設定_ON</span></h2>
            <div class="comment">
                <p><code>12DmSetting.vue</code>108行目~ は設定項目が増えた時用の見本</p>
            </div>
            <DmSettingComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ブランド- チーム管理

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ブランド- チーム管理</span></h2>
            <div class="comment">
                <p>権限変更用のモーダルを開くには<code>19Modal.vue</code>でMountedしているjsのコードが必要になります。</p>
            </div>
            <TeamComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ブランド- メンバー招待画面

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ブランド- メンバー招待画面</span></h2>
            <div class="comment">
                <p>xxxxxxx</p>
            </div>
            <TeamInvitationComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                ダッシュボード

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>ダッシュボード</span></h2>
            <div class="comment">
                <p>未読は太字のリンクカラー。</p>
            </div>
            <DashboardComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                プランセレクト

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>プランセレクト</span></h2>
            <div class="comment">
                <p>リンク先はアテで入れてます。</p>
            </div>
            <PlanSelectComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                NoImage

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>NoImage</span></h2>
            <div class="comment">
                <p> NoImage を表示させたい <span class="md_text-bold _link-color">img を ラップしている要素 (.img-wrapなど) </span> に<br><code>md_no-image</code>を付与してください。</p>
            </div>
            <NoImageComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                LikeUsCard

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>LikeUsCard</span></h2>
            <div class="comment">
                <p>ショップ - ブランド一覧下部に表示する<span class="md_text-bold _link-color">いいねを押したブランド一覧。</span></p>
            </div>
            <LikeUsCardComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                Modal

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>Modal</span></h2>
            <div class="comment">
                <p>トリガーになる button などの要素に<code>data-modal="HogeHoge"</code>(Aとする)を追加して、開きたいモーダルの<code>.modal_container</code>に対して、Aを追加してマルチクラスにすると対象のモーダルが開きます。</p>
                <p><code>button data-modal="HogeHoge"</code></p>
                <p><code>div.class="modal_container HogeHoge"</code></p>
                <p>↑こんな感じにする。命名規則としてはアッパーキャメルでやってますがお好きにどうぞ！</p>
                <p>1ページ内にモーダルが複数必要な場合は、必要な数分のモーダルを用意しないといけませんが、背景用に設置してある<code>.modal-bg</code>は、ページ内で一個あれば良いです。</p>
                <br>
                <p>また、<code>.modal_container</code>にヘルパークラスとして<code>._delete</code>をつけて<code>div class="modal_container _delete"</code>にすると、モーダル内のタイトルが赤くなり警告アラートっぽくなります。</p>
                <br>
                <p><code>.js-modal-close</code>のclassが付いた要素をクリックすると開いているモーダルが閉じます。</p>
                <br>
                <p>以下のボタンは見本です。</p>
            </div>
            <ModalComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                404

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>404 NotFound</span></h2>
            <div class="comment">
                <p></p>
            </div>
            <NotFoundComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                CropperParts

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>CropperParts</span></h2>
            <div class="comment">
                <p></p>
            </div>
            <CropperPartsComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                価格軸設定画面 - ユーザー

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>価格軸設定画面 - ユーザー</span></h2>
            <div class="comment">
                <p></p>
            </div>
            <PriceAxisUserComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                価格軸設定画面 - 運営

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->
            <h2 class="heading_component"><span>価格軸設定画面 - 運営</span></h2>
            <div class="comment">
                <p></p>
            </div>
            <PriceAxisAdminComponent />

            <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::::

                /ComponentEnd

            :::::::::::::::::::::::::::::::::::::::::::::::::::::::::  -->

        </div><!--/.ly_main .inner-->
    </div><!--/.ly_main .wrap-->

    <div class="heading_page-title-en"><span>Component</span></div>
</main>

</layout>
</template>


<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import dayjs from 'dayjs'
    import { Link } from '@inertiajs/inertia-vue3'

    //ComponentList.vue
    import InputComponent from '@/components/Admin/ComponentList/01Input'
    import InputValidationComponent from '@/components/Admin/ComponentList/01InputValidation'
    import LinkBtnComponent from '@/components/Admin/ComponentList/02LinkBtn'
    import IconBtnComponent from '@/components/Admin/ComponentList/03IconBtn'
    import IconBtnNoticeComponent from '@/components/Admin/ComponentList/04IconBtnNotice'
    import UserSettingComponent from '@/components/Admin/ComponentList/05UserSetting'
    import NewsComponent from '@/components/Admin/ComponentList/06News'
    import NewsRecentComponent from '@/components/Admin/ComponentList/07NewsRecent'
    import NewsRegisterComponent from '@/components/Admin/ComponentList/08NewsRegister'
    import PaginationComponent from '@/components/Admin/ComponentList/09Pagination'
    import TalkComponent from '@/components/Admin/ComponentList/10Talk'
    import DmRegisterComponent from '@/components/Admin/ComponentList/11DmRegister'
    import DmSettingComponent from '@/components/Admin/ComponentList/12DmSetting'
    import TeamComponent from '@/components/Admin/ComponentList/13Team'
    import TeamInvitationComponent from '@/components/Admin/ComponentList/14TeamInvitation'
    import DashboardComponent from '@/components/Admin/ComponentList/15Dashboard'
    import PlanSelectComponent from '@/components/Admin/ComponentList/16PlanSelect'
    import NoImageComponent from '@/components/Admin/ComponentList/17NoImage'
    import LikeUsCardComponent from '@/components/Admin/ComponentList/18LikeUsCard'
    import ModalComponent from '@/components/Admin/ComponentList/19Modal'
    import NotFoundComponent from '@/components/Admin/ComponentList/20NotFound'
    import CropperPartsComponent from '@/components/Admin/ComponentList/21CropperParts'
    import PriceAxisUserComponent from '@/components/Admin/ComponentList/22PriceAxisUser'
    import PriceAxisAdminComponent from '@/components/Admin/ComponentList/23PriceAxisAdmin'

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            //ComponentList
            InputComponent,
            InputValidationComponent,
            LinkBtnComponent,
            IconBtnComponent,
            IconBtnNoticeComponent,
            UserSettingComponent,
            NewsComponent,
            NewsRecentComponent,
            NewsRegisterComponent,
            PaginationComponent,
            TalkComponent,
            DmRegisterComponent,
            DmSettingComponent,
            TeamComponent,
            TeamInvitationComponent,
            DashboardComponent,
            PlanSelectComponent,
            NoImageComponent,
            LikeUsCardComponent,
            ModalComponent,
            NotFoundComponent,
            CropperPartsComponent,
            PriceAxisUserComponent,
            PriceAxisAdminComponent,
        },
        data() {
            return {
                showPagination: false,
                links: '',
            }
        },
        props: {
            news: Object,
            user: Object,
            company: Object,
            shops: Object,
            brands: Object,
        },
    }
</script>
